import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import Avatar from "../common/Avatar.vue.mjs";
import { useI18n } from "../../locales/index.mjs";
import EnterRoomIcon from "../common/icons/EnterRoomIcon.vue.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import TuiButton from "../common/base/Button.vue.mjs";
import { TUIConferenceInvitationManagerEvents, TUIInvitationRejectedReason } from "@tencentcloud/tuiroom-engine-js";
import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import "../../utils/environment.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "InvitationNotification",
  emits: ["join-conference"],
  setup(__props, { emit: emits }) {
    const invitationInfo = ref({
      userId: "",
      userName: "",
      avatarUrl: "",
      roomName: "",
      roomMemberCount: 0,
      roomOwner: "",
      roomId: ""
    });
    const { t } = useI18n();
    const showInvitation = ref(false);
    const onReceiveInvitation = (data) => {
      const { roomInfo, invitation } = data;
      invitationInfo.value.userId = invitation.inviter.userId;
      invitationInfo.value.userName = invitation.inviter.userName;
      invitationInfo.value.avatarUrl = invitation.inviter.avatarUrl;
      invitationInfo.value.roomName = roomInfo.roomName;
      invitationInfo.value.roomMemberCount = roomInfo.roomMemberCount;
      invitationInfo.value.roomOwner = roomInfo.roomOwner;
      invitationInfo.value.roomId = roomInfo.roomId;
      setInvitationDisplay(true);
    };
    const handleEnterRoom = () => {
      const { roomId } = invitationInfo.value;
      roomService.conferenceInvitationManager.accept({ roomId });
      setInvitationDisplay(false);
      emits("join-conference", {
        roomId,
        roomParam: {
          isOpenCamera: false,
          isOpenMicrophone: true
        }
      });
    };
    const handleRejectInvitation = () => {
      const { roomId } = invitationInfo.value;
      roomService.conferenceInvitationManager.reject({
        roomId,
        reason: TUIInvitationRejectedReason.kRejectToEnter
      });
      setInvitationDisplay(false);
    };
    const onInvitationTimeout = () => {
      setInvitationDisplay(false);
    };
    const onInvitationHandledByOtherDevice = () => {
      setInvitationDisplay(false);
    };
    const setInvitationDisplay = (options) => {
      showInvitation.value = options;
    };
    onMounted(() => {
      roomService.conferenceInvitationManager.on(
        TUIConferenceInvitationManagerEvents.onReceiveInvitation,
        onReceiveInvitation
      );
      roomService.conferenceInvitationManager.on(
        TUIConferenceInvitationManagerEvents.onInvitationTimeout,
        onInvitationTimeout
      );
      roomService.conferenceInvitationManager.on(
        TUIConferenceInvitationManagerEvents.onInvitationHandledByOtherDevice,
        onInvitationHandledByOtherDevice
      );
    });
    onUnmounted(() => {
      roomService.conferenceInvitationManager.off(
        TUIConferenceInvitationManagerEvents.onReceiveInvitation,
        onReceiveInvitation
      );
      roomService.conferenceInvitationManager.off(
        TUIConferenceInvitationManagerEvents.onInvitationTimeout,
        onInvitationTimeout
      );
      roomService.conferenceInvitationManager.off(
        TUIConferenceInvitationManagerEvents.onInvitationHandledByOtherDevice,
        onInvitationHandledByOtherDevice
      );
    });
    return { __sfc: true, invitationInfo, t, showInvitation, emits, onReceiveInvitation, handleEnterRoom, handleRejectInvitation, onInvitationTimeout, onInvitationHandledByOtherDevice, setInvitationDisplay, Avatar, EnterRoomIcon, SvgIcon, TuiButton };
  }
});
export {
  _sfc_main as default
};
